import { Dispatch, SetStateAction, useCallback } from 'react';
import { AllocationModalParams } from 'components/organisms/resource-management/manage-allocation';
import { AllocationEventModel } from 'components/organisms/resource-management/scheduler-config/models';
import { CommonManagerProps } from '../../types';

type ReturnProps = () => void;

interface Props extends CommonManagerProps {
  currentEvent: AllocationEventModel | undefined;
  setCurrentEvent: Dispatch<SetStateAction<AllocationEventModel | undefined>>;
  setAllocationModalParams: Dispatch<
    SetStateAction<AllocationModalParams | undefined>
  >;
}

export const useAllocationEventCancelHandler = ({
  schedulerRef,
  currentEvent,
  setCurrentEvent,
  setAllocationModalParams,
}: Props): ReturnProps => {
  return useCallback(() => {
    if (currentEvent != null && currentEvent.id < 0) {
      schedulerRef.current.instance.eventStore.remove(currentEvent);
    }
    currentEvent?.set('active', false);
    setAllocationModalParams(undefined);
    setCurrentEvent(undefined);
  }, [currentEvent, schedulerRef, setAllocationModalParams, setCurrentEvent]);
};
